module.exports = __webpack_public_path__ + "img/841981906.a9003152.jpg";